/** @jsx jsx */

import { jsx } from '@emotion/core';

import InputWithLabel from './InputWithLabel';
import { sectionStyle } from './constants';

type Props = {
  jobTitle: string;
  onChange: (jobTitleNext: string) => void;
};

function SectionJobTitle({ jobTitle, onChange }: Props) {
  return (
    <div css={sectionStyle}>
      <InputWithLabel
        aria-describedby="job-title"
        aria-invalid={false}
        aria-label="Job Title"
        aria-required={false}
        id="job-title"
        name="job-title"
        onChange={onChange}
        title="Job Title"
        value={jobTitle}
      />
    </div>
  );
}

export default SectionJobTitle;
